import getDaysInMonth from 'date-fns/getDaysInMonth';

import { MONTH_NAMES } from '../constants';

import dateOfBirthUrl from './dateOfBirthComponent.html';

class DateOfBirthCtrl {
  constructor(Authentication, $scope) {
    'ngInject';

    Object.assign(this, { Authentication, $scope });
  }

  $onInit() {
    this.days = this.getDaysOptions(31);

    this.months = MONTH_NAMES[this.monthsAbbreviation ? 'monthsAbbr' : 'months'].map(
      (label, value) => ({ label, value })
    );

    this.years = [];
    const currentYear = new Date().getFullYear();
    for (let y = 1900; y <= currentYear; y++) {
      this.years.push({ label: y, value: y });
    }

    this.$scope.$watch(() => this.ngModel.$modelValue, this.recalculateFields);
    this.month;
    this.$scope.$watch(
      () => `${this.month}-${this.year}`,
      () => this.recalculateDaysInMonth(this.month, this.year)
    );
  }

  $onChanges({ resetCounter }) {
    if (resetCounter && !resetCounter.isFirstChange()) {
      this.recalculateFields(this.ngModel.$modelValue);
    }
  }

  recalculateDaysInMonth = (month, year) => {
    const daysInMonth = this.getMonthDays(month, year);

    if (daysInMonth !== this.days.length) {
      this.days = this.getDaysOptions(daysInMonth);
    }
  };

  getMonthDays = (month, year) => {
    const todayDate = new Date();
    const mth = month || 0;
    const yr = year || todayDate.getFullYear();

    return getDaysInMonth(new Date(yr, mth));
  };

  getDaysOptions = (numberOfDays) => {
    const days = [];
    for (let d = 1; d <= numberOfDays; d++) {
      days.push({ label: d, value: d });
    }
    return days;
  };

  recalculateFields = (model) => {
    if (model instanceof Date) {
      this.day = model.getDate();
      this.month = model.getMonth();
      this.year = model.getFullYear();

      this.recalculateDaysInMonth(this.month, this.year);

      if (!this.days.find((d) => d.value === this.day)) {
        this.day = undefined;
      }

      if (!this.months.find((m) => m.value === this.month)) {
        this.month = undefined;
      }

      if (!this.years.find((y) => y.value === this.year)) {
        this.year = undefined;
      }
    } else {
      this.day = undefined;
      this.month = undefined;
      this.year = undefined;
    }
  };

  changed() {
    if (this.isValidDate()) {
      this.ngModel.$setViewValue(new Date(this.year, this.month, this.day));
      this.ngModel.$setValidity('invalid-date', true);
    } else {
      this.ngModel.$setViewValue(null);
      this.ngModel.$setValidity('invalid-date', false);
    }
  }

  isValidDate() {
    return (
      typeof this.day === 'number' &&
      !Number.isNaN(this.day) &&
      typeof this.month === 'number' &&
      !Number.isNaN(this.month) &&
      typeof this.year === 'number' &&
      !Number.isNaN(this.year)
    );
  }
}

export default {
  controller: DateOfBirthCtrl,
  controllerAs: 'ctrl',
  templateUrl: dateOfBirthUrl,
  require: {
    ngModel: 'ngModel',
  },
  bindings: {
    isDisabled: '<ngDisabled',
    resetCounter: '<',
    monthsAbbreviation: '<',
    decreseZIndex: '<?',
  },
};
